export const contextPanels = {
	title: {
		about: 'About',
		addAppliance: 'Add Appliance',
		addCustomAppliance: 'Add Custom Appliance',
		addCutout: 'Add Cutout',
		applianceProperties: 'Appliance Properties',
		backsplashProperties: 'Backsplash Properties',
		blueprintValidation: 'Validation Items',
		connectionProperties: 'Connection Properties',
		countertopProperties: 'Countertop Properties',
		customApplianceProperties: 'Custom Appliance Properties',
		cutoutProperties: 'Cutout Properties',
		addSpacer: 'Add Space Reservation',
		spacerProperties: 'Space Reservation Properties',
		designerOptions: 'Designer Options',
		findCustomerProperties: 'Selection Details',
		islandProperties: 'Island Properties',
		kitchenProperties: 'Kitchen Properties',
		renderingProperties: 'Rendering',
		swapAppliance: 'Swap Appliance'
	},
	tooltip: {
	},
	message: {
		swapAppliance: 'Note: Swap appliances should match same item placement.'
	},
	renderingUpload: {
		label: 'Upload Image',
		hint: 'Drag & drop or click to browse (PNG or JPEG)',
		setAsRendering: 'Set As Rendering',
		chooseDifferent: 'Choose different',
		clickToSet: 'Click to set this image as your rendering',
		invalidType: {
			title: 'Unsupported file type',
			description: 'Please upload a PNG or JPEG image.'
		},
		confirm: {
			title: 'Replace current rendering?',
			body: 'A rendering already exists for this design. Replacing it will overwrite the current one, which may still be relevant. Keep the existing rendering or replace it with your upload.',
			replace: 'Replace',
			keep: 'Keep Existing'
		}
	},
	customAppliance: {
		placeholderModel: {
			label: 'Placeholder Model',
			helperText: 'Pick a similar product whose 3D model will be shown as a placeholder. The placeholder will render with a red tint to indicate it is not the real appliance.',
			placeholder: 'Search by SKU, name, or description...',
			clear: 'clear'
		}
	}
};
